// The join-us card shown on page 1 takes the room of two products
export const JOIN_CARD_SLOTS = 2

export interface PageWindow {
  pinnedFrom: number
  pinnedTo: number // pinned products to show: pinned.slice(pinnedFrom, pinnedTo)
  offset: number // offset to request from the products API
  limit: number // how many products to request from the API
}

/**
 * Which products a page shows.
 *
 * The listing is one virtual list: the pinned products first (e.g. a category's top products),
 * followed by the API results. Page 1 shows `size - JOIN_CARD_SLOTS` of them (the join card fills
 * the rest); every later page continues right after and shows `size`.
 */
export const getPageWindow = (
  page: number,
  size: number,
  pinnedCount = 0
): PageWindow => {
  const start = page === 1 ? 0 : size * (page - 1) - JOIN_CARD_SLOTS
  const end = page === 1 ? size - JOIN_CARD_SLOTS : start + size

  const pinnedFrom = Math.min(start, pinnedCount)
  const pinnedTo = Math.min(end, pinnedCount)
  return {
    pinnedFrom,
    pinnedTo,
    offset: Math.max(start - pinnedCount, 0),
    limit: end - start - (pinnedTo - pinnedFrom),
  }
}

// Slot of the join card on page 1, avoiding positions that would break the grid rows
export const getJoinCardPosition = (): number => {
  const position = Math.floor(Math.random() * 15 + 8)
  return [11, 15, 19].includes(position) ? position - 1 : position
}
